export const COLOR_IN_USE_ERROR_CODE = 10007;
export const PRODUCT_NOT_PURCHASABLE_ERROR_CODE = 10011;
export const SHIPPING_COST_CHANGED_REASON_CODE = 'SHIPPING_COST_CHANGED';
export const SHIPPING_SERVICE_UNAVAILABLE_REASON_CODE = 'SHIPPING_SERVICE_UNAVAILABLE';
export const SHIPPING_CARRIER_UNAVAILABLE_REASON_CODE = 'CARRIER_UNAVAILABLE';
export const SHIPPING_NOT_CONFIGURED_REASON_CODE = 'SHIPPING_NOT_CONFIGURED';
export const SHIPPING_COMMUNE_WITHOUT_COVERAGE_REASON_CODE = 'COMMUNE_WITHOUT_COVERAGE';
